export const localizedDate = (date: Date, language = 'en'): string => {
  const dateFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  };

  // @ts-ignore
  const dateFormat = new Intl.DateTimeFormat(language, dateFormatOptions);

  return dateFormat.format(date);
};
